// noinspection ES6UnusedImports
import lottie from 'lottie-web';
import {GooglePlaces} from "../app/GooglePlaces";

window.initMap = new GooglePlaces().initMap;



